/**
 * Durable tour-completion flag. Auth0 user_metadata is the source of truth
 * (written by user-manager's MarkTourCompleted); sessionStorage covers the gap
 * until the next token refresh so the tour doesn't re-auto-start in the same
 * session while the claim is still stale.
 */
import { UserClient } from '../client/client';

const SESSION_KEY = 'tc_tour_done:v1';

export const isTourDoneThisSession = (): boolean => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * Fire-and-forget: optimistic session mark + background RPC. Never throws.
 * Takes the authed client factory from useUserClient() — a plain util cannot
 * call the hook itself.
 */
export function markTourCompleted(getClient: () => Promise<UserClient>): void {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    /* private browsing */
  }
  getClient()
    .then((client) => client.markTourCompleted())
    .catch((err) => console.warn('[tour] markTourCompleted failed (will retry next exit)', err));
}
